export default "__VITE_ASSET__C0FCl5CP__"